<template>
<div class="mb-4">

    <div class="mt-5 p-3" style="background-color: #171A28E3;">
    <div class="container footer">
      <div class="row">
        <div class="col-md-8 text-center">
          <span class="text_azul text_bold text_13"> ENTRE EM NOSSO CANAL DO TELEGRAM E PARTICIPE DE TORNEIOS GRÁTIS EXCLUSIVOS</span>
        </div>
        <div class="col-md-4">

          <a href="https://t.me/sokkerduel" class="btn btn-info w-100 text_12 text_bold" target="_blank">ENTRE EM NOSSO TELEGRAM </a>
        </div>
      </div>
    </div>
    </div>

    <div class="container footer mt-5">
      <div class="row">
        <div class="col-md-2 text-center">
          <img :src='"../../assets/image/logo_sokker_branco.png"' alt="Responsive image" :title='"sokkerduel"' width="160px" class="mb-3 live-chat-image">
          <a href="https://suporte.sokkerduel.com/" class="btn btn-secondary w-100 text_bold mb-2 text_12" target="_blank">
            CENTRAL DE SUPORTE
          </a>
          <!-- <button class="btn btn-secondary w-100 text_bold text_12 text_preto">SUPORTE VIA TICKET</button>         -->
        </div>
        <div class="col-md-10">

          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="text_branco text_bold text_12 mb-3">Sobre Nós</div>
              <div class="text_cinza text_12">
                A SokkerDUEL é operado pela Realizegreen Unipessoal LDA, uma empresa estabelecida em Portugal com o número de registro 517048078, 
                com seu endereço registrado Rua Campo Alegre N1517 24 C12 4150-182 PORTO. A SokkerDUEl é um site do tipo fantasy game, que organiza 
                torneios de palpites, isento de licença no Brasil pela Lei nº 14.790/2023. 
                A SokkerDUEL promove um novo tipo de jogo onde a sua habilidade conta mais do que a sorte.
              </div>
            </div>
            <div class="col-md-12 mb-4">
              <div class="row">
                <div class="col-md-4">
                  <div class="text_branco text_bold text_12 mb-2">Links Úteis</div>
                  <div><a href="https://sokkerduel.com/como-funciona/termo-de-uso/" target="_blank" class="text_cinza text_12 mb-3">Termos de Uso</a></div>
                  <div><a href="https://sokkerduel.com/como-funciona/politica-anti-lavagem-dinheiro/" target="_blank" class="text_cinza text_12 mb-3">Politica Antilavagem de Dinheiro</a></div>
                  <div><a href="https://sokkerduel.com/como-funciona/politica-de-privacidade/" target="_blank" class="text_cinza text_12 mb-3">Politica de Privacidade</a></div>
                  <div><a href="https://sokkerduel.com/como-funciona/regras-do-torneio/" target="_blank" class="text_cinza text_12 mb-3">Regras da SokkerDuel</a></div>
                  <div><a href="https://sokkerduel.com/como-funciona/#faq" target="_blank" class="text_cinza text_12 mb-3">Perguntas Frequentes</a></div>
                </div>
                <div class="col-md-4">
                  <div class="text_branco text_bold text_12 mb-2">Método de Pagamento</div>
                  <div><img :src='"../../assets/image/pix.png"' alt="Responsive image" :title='"sokkerduel"' width="100px" class="mb-3"></div>
                </div>
                <div class="col-md-4">
                  <div class="text_branco text_bold text_12 mb-2">Entre em contato</div>
                  <div class="text_12 text_cinza">info@sokkerduel.com</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

</div>
</template>

<script>

  export default {
    data(){
      return{}
    },
  }

</script>

<style scoped>

  .live-chat-image {
      opacity: 0.7; /* Altere o valor conforme necessário (0 a 1) */
  }

</style>


// WEBPACK FOOTER //
// src/components/layout/footer.vue